export const InstallmentStatus = {
  PENDING: "PENDING",
  OVERDUE: "OVERDUE",
  PAID: "PAID",
  REFUNDED: "REFUNDED",
};
